import React, { useState, useEffect  } from 'react';
import '../../App.css';
// import OtherUserProfile from '../OtherUserProfile';
import './css/SignUp.css';
import axios from "axios";
import baseurl from "../../App"
import { useGoogleLogin  } from '@react-oauth/google';

function Login() {
    const [inputs, setInputs] = useState({});
	const [credentialError, setCredentialError] = useState('');
    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        console.log(value)
        setInputs(values => ({...values, [name]: value}))
    }
	// setCredentialError("Get Started");
	
	// useEffect(() => {
		// const loggedInUser = localStorage.getItem("user");
		// if (loggedInUser) {
		  // const foundUser = JSON.parse(loggedInUser);
		  // setUser(foundUser);
		// }
	  // }, []);
    const [ user, setUser ] = useState([]);
    
    const glogin = useGoogleLogin({
        onSuccess: (codeResponse) => setUser(codeResponse),
        onError: (error) => console.log('Login Failed:', error)
    });
  
    useEffect(
        () => {
            if (user) {
                axios
                    .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`, {
                        headers: {
                            Authorization: `Bearer ${user.access_token}`,
                            Accept: 'application/json'
                        }
                    })
                    .then(async (res) => {
                        console.log(res.data);
                        const guser  = res.data;
                        await axios.post('https://api.bubble.africa/users/login', {
                            email: guser.email,
                            password: guser.id,
                            gUser: true,
                        }, {headers: { 'Content-Type': 'application/json' }})
                            .then((res) => {
                                // const value = reference.current;
                                // Update reference value:
                                setCredentialError("User logged in successfully");
                                // let msg = ;
                                // set the state of the user
                                // setUser(res.data)
                                // store the user in localStorage
                                console.log(res)
                                localStorage.setItem('user', JSON.stringify(res.data));
                                // console.log(res.data)
                                // navigate.push("/dashboard");
                                window.location.href='/dashboard';
                                
                            }).catch((error) => {
                                console.log(inputs, baseurl());
                                setCredentialError(error.response.data);
                                // const error_stat = error.response.status;
                                // console.log(error.response.status);
                                // if (error_stat == 400) {
                                    
                                    // console.log(msg.current);
                                // }
                                // console.log(error)
                                
                            });
                    })
                    .catch((err) => console.log(err));
            }
        },
        [ user ]
    );

    const handleSubmit = async (event) => {
        // if (!this.validate()) { event.preventDefault() }
        event.preventDefault();
		
        console.log(inputs);
		await axios.post('https://api.bubble.africa/users/login', {
			email: inputs.email,
			password: inputs.password
		}, {headers: { 'Content-Type': 'application/json' }})
            .then((res) => {
				// const value = reference.current;
				// Update reference value:
				setCredentialError("User logged in successfully");
				// let msg = ;
				// set the state of the user
				// setUser(res.data)
				// store the user in localStorage
                console.log(res)
				localStorage.setItem('user', JSON.stringify(res.data));
                // console.log(res.data)
				// navigate.push("/dashboard");
				window.location.href='/dashboard';
				
            }).catch((error) => {
                console.log(inputs, baseurl());
				setCredentialError(error.response.data);
				// const error_stat = error.response.status;
				// console.log(error.response.status);
				// if (error_stat == 400) {
					
					// console.log(msg.current);
				// }
                // console.log(error)
				
            });
    }
    return (
        <div className='container'>
            <div className='signup-container'>
                <img className='signup-logo' src='./images/bubble.svg' alt='logo'/>
                <h3 className='subheader green-text'>Welcome back To Bubble</h3>
                <p className='maintext signup-sub'>{credentialError ? credentialError: "Enter your email and password"}</p>
                <div className='continuewithgoogle'>
                    <div className='google-text'>
                        <p onClick={() => glogin()} className='googletext'>Sign In with Google  <img src='../../images/google-logo.png' alt='google-logo' width='21px'/>
                        </p>
                    </div>
                </div>
                <div className='signup-group'>
                    <hr className='signup-hr'/>
                    <p className='maintext'>or</p>
                    <hr className='signup-hr'/>
                </div>
                <form className='signup' onSubmit={handleSubmit}>
                    <input name="email" value={inputs.email || ""} onChange={handleChange} type="email" className="signup-input" placeholder="Enter your email address" />
                    <input name="password" value={inputs.password || ""} onChange={handleChange} type="password" className="signup-input" placeholder="Enter your password" />
                    <p className='subtext left'> <a href='/login' >Forgot your password?</a></p>
                    <button className='signup-submit' type = 'submit'>Login</button>
                    {/* <input type="submit"  className='signup-submit' value="Login"/> */}
                </form>
                {/* <p>{testing}</p> */}
                <p className='subtext'>Don't have an account? <a href="/sign-up">Sign Up</a></p><br/><br/><br/>
                </div>
            
        </div>
        
    )
}

export default Login;